import "./index.scss";

import { Box } from "@mui/material";
import TitleWithOptions from "components/TitleWithOptions";
import { TMemberDetails } from "models/member";
import { useEffect, useState } from "react";

const ContactsPerson = (props: { member: TMemberDetails; editCallback: Function }) => {
  const { member, editCallback } = props;
  const [contactsVisibile, setContactsVisible] = useState(false);

  useEffect(() => {
    if (member?.contacts) {
      let isContactVisible = false;
      Object.keys(member.contacts).forEach((key) => {
        if (member.contacts[key]) {
          isContactVisible = true;
          return;
        }
      });
      setContactsVisible(isContactVisible);
    }
  }, [member]);

  if (!contactsVisibile) return null;
  return (
    <Box className="contacts-person-container">
      <TitleWithOptions title="Contacts" edit={editCallback} />
      <Box display="flex" gap={1} mt={2}>
        {member?.contacts &&
          Object.keys(member?.contacts).map((m, i) => {
            if (!member?.contacts[m]) return null;
            return (
              <ContactCard
                key={`contactCard${i}`}
                title={m}
                name={member?.contacts[m].name}
                phone={member?.contacts[m].phone}
                relationship={member?.contacts[m].relationship || member?.contacts[m].speciality}
              />
            );
          })}
      </Box>
    </Box>
  );
};

const ContactCard = ({ title, name, phone, relationship }) => {
  return (
    <Box flex={1} className="card">
      <p className="type">{title}</p>
      <p className="name">{name}</p>
      <p className="relation">{relationship}</p>
      <p className="contact">{phone}</p>
    </Box>
  );
};

export default ContactsPerson;
